import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { SplitButtonModule } from 'primeng/splitbutton';

import { topToBottom } from '@animations/topToBottom.anim';

import { registerChartPlugins } from '@cxc/ui-kit/chart.js/plugins';

import { DashboardHeaderComponent } from '@layouts/dashboard/components/header/header.component';
import { DashboardMainComponentt } from '@layouts/dashboard/components/main/main.component';

@Component({
  selector: 'dashboard-layout',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,

    DashboardHeaderComponent,
    DashboardMainComponentt,
    SplitButtonModule,
  ],

  animations: [topToBottom],
})
export class DashboardLayout {
  constructor() {
    registerChartPlugins();
  }
}
